import { render } from "./DonateHistory.vue?vue&type=template&id=22cd6fb3"
import script from "./DonateHistory.vue?vue&type=script&lang=js"
export * from "./DonateHistory.vue?vue&type=script&lang=js"
script.render = render

export default script